import styled from 'styled-components';

export const SectionContainer = styled.section`
  max-width: ${(p) => p.theme.sizes.mwInner};
  margin: 0 auto;
  padding: 70px 20px;
`;

export const SectionTitle = styled.h3`
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 28px;
  font-family: inherit;
`;
